import React, { Component } from "react";

// import logo1 from 'assets/images/logo/switzerland.png';
// import logo2 from 'assets/images/logo/eurail.png';

import i18n from "i18n-react";
import { StorageHandler, BackImage } from "C4";
import { storageKeys } from "settings";
import { HashLink as Link } from "react-router-hash-link";

export default class RewardsView extends Component {
  render() {
    const params = new URLSearchParams(window.location.search);
    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }

    return (
      <div className="contentContainer BookingForm">
        <BackImage />
        <div className="header">
          <Link to="/main" />
          <h3>{i18n.translate("rewards.bookingForm.title")}</h3>
        </div>
        <hr />
        <div className="bodyRewards">
          <img
            src="https://front.travpromobile.com/1439/final-header.png"
            alt="sidebar"
          />
          <h1>Earn cash rewards for your Tampa Bay bookings.*</h1>
          <div className="holder">
            <p>
              <b>Monthly Grand Prize</b>
              <br />
              $500 for the travel advisor booking the highest number of guests
              to Tampa Bay.
              <br />
              <br />
              <b>Monthly First Runner-Up</b>
              <br />
              $250 for the travel advisor booking the next-highest number of
              guests to Tampa Bay.
              <br />
              <br />
              <b>Monthly Second Runner-Up</b>
              <br />
              $100 for the travel advisor booking the next-highest number of
              guests to Tampa Bay.
              <br />
              <br />
              <b>1 Monthly Winner Chosen at Random</b>
              <br />
              $100 for one randomly selected travel advisor with qualifying
              bookings of guests to Tampa Bay.
              <br />
              <br />
              *Bookings entered are valid only after client&apos;s travel is
              completed.
              <br />
              <br />
              See program{" "}
              <Link className="terms" to="/main/rewards/terms">
                Terms & Conditions
              </Link>{" "}
              for details.
            </p>
          </div>
          <div className="buttonHolder">
            {mobile && (
              <Link to="/main/rewards/form?mobile=true">
                <button type="button" className="btn">
                  {i18n.translate("rewards.bookingForm.button")}
                </button>
              </Link>
            )}
            {!mobile && (
              <Link to="/main/rewards/form">
                <button type="button" className="btn">
                  {i18n.translate("rewards.bookingForm.button")}
                </button>
              </Link>
            )}
          </div>
        </div>
        {mobile && (
          <style>
            {
              "\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }"
            }
          </style>
        )}
      </div>
    );
  }
}
